/// <reference types="vite/client" />

export const ANALYTICS_ID =
  (import.meta.env.VITE_GA_MEASUREMENT_ID as string | undefined) ||
  (import.meta.env.GA_MEASUREMENT_ID as string | undefined) ||
  (import.meta.env.VITE_GA_ID as string | undefined) ||
  (import.meta.env.GA_ID as string | undefined);
const ANALYTICS_SCRIPT_ID = 'google-analytics';
export const ANALYTICS_IDLE_FALLBACK_MS = 2000;

function loadAnalytics(measurementId: string) {
  if (document.getElementById(ANALYTICS_SCRIPT_ID)) return;

  const script = document.createElement('script');
  script.id = ANALYTICS_SCRIPT_ID;
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${measurementId}`;
  document.head.appendChild(script);

  window.dataLayer = window.dataLayer || [];
  window.gtag = function gtag() {
    // Google Analytics expects each command as the function's array-like arguments object.
    // eslint-disable-next-line prefer-rest-params
    window.dataLayer?.push(arguments);
  };
  window.gtag('js', new Date());
  window.gtag('config', measurementId);
}

export function initAnalytics(isProduction = import.meta.env.PROD, measurementId = ANALYTICS_ID) {
  if (!isProduction || !measurementId) return;

  const scheduleAfterIdle = () => {
    const fallbackId = window.setTimeout(
      () => loadAnalytics(measurementId),
      ANALYTICS_IDLE_FALLBACK_MS,
    );
    window.requestIdleCallback?.(
      () => {
        window.clearTimeout(fallbackId);
        loadAnalytics(measurementId);
      },
      { timeout: ANALYTICS_IDLE_FALLBACK_MS },
    );
  };

  if (document.readyState === 'complete') scheduleAfterIdle();
  else window.addEventListener('load', scheduleAfterIdle, { once: true });
}
